/*
 * Design: Command Center — Dark Operations Dashboard
 * Minimal footer with logo, links, copyright
 * Demo AI Now CTA
 */

import { useLocation } from "wouter";

const LOGO_URL = "https://files.manuscdn.com/user_upload_by_module/session_file/105433247/qBHQzWZzhhwDPsto.png";

const footerLinks = [
  { label: "Services", href: "#services" },
  { label: "Pulse System", href: "/pulse" },
  { label: "AI Systems", href: "#ai-systems" },
];

export default function Footer() {
  const [, navigate] = useLocation();

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    if (href.startsWith("/")) {
      navigate(href);
      return;
    }
    const el = document.querySelector(href);
    if (el) {
      const offset = 80;
      const top = el.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  return (
    <footer className="border-t border-white/5 py-12 sm:py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8">
          {/* Logo + Name */}
          <div className="flex items-center gap-3">
            <img src={LOGO_URL} alt="The AI Assistant Lab" className="h-9 w-9" />
            <span className="text-white font-semibold text-lg tracking-tight">
              The AI Assistant Lab
            </span>
          </div>

          {/* Links */}
          <div className="flex flex-wrap items-center gap-6 sm:gap-8">
            {footerLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => handleNavClick(e, link.href)}
                className="text-zinc-400 hover:text-zinc-200 text-sm transition-colors duration-200"
              >
                {link.label}
              </a>
            ))}
            <a
              href="sms:+15039987760?body=Hi%20Luis%2C%20I%27m%20interested%20in%20learning%20more%20about%20your%20AI%20systems%20and%20GHL%20services."
              className="text-purple-400 hover:text-purple-300 text-sm font-medium transition-colors duration-200"
            >
              Text Me
            </a>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-zinc-400 text-sm">
            &copy; {new Date().getFullYear()} The AI Assistant Lab. All rights reserved.
          </p>
          <p className="text-zinc-300 text-xs">
            AI-powered systems for agency growth.
          </p>
        </div>
      </div>
    </footer>
  );
}
